import { useEffect } from 'react';

export function useScrollListener(handler: () => void, condition?: boolean) {
  useEffect(() => {
    if (condition === false) {
      return undefined;
    }

    const fn = () => handler?.();
    document.addEventListener('scroll', fn, { passive: true, capture: true });

    return () => document.removeEventListener('scroll', fn, { capture: true });
  }, [handler, condition]);
}
